import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { InstitutionalSalesComponent } from './institutional-sales.component';

const routes: Routes = [
  {
    path: 'institutional-sales',
    data: { name: 'Institutional Sales', isTab: true },
    component: InstitutionalSalesComponent,
  },
];

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule],
})
export class InstitutionalSalesPageRoutingModule {}
